module.exports = __webpack_public_path__ + "img/product_xj.abef507d.png";